module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "calendar-weekdays"
  }, _vm._l((_vm.weekdays), function(weekday, i) {
    return _c('div', {
      key: ("weekday-" + i),
      staticClass: "calendar-weekday"
    }, [_vm._v("星期" + _vm._s(weekday))])
  })), _vm._l((_vm.dates), function(week, i) {
    return _c('div', {
      key: i,
      staticClass: "calendar-week"
    }, _vm._l((week), function(day, j) {
      return _c('CalendarDay', _vm._g(_vm._b({
        key: j,
        staticClass: "calendar-day",
        model: {
          value: (day.tasks),
          callback: function($$v) {
            _vm.$set(day, "tasks", $$v)
          },
          expression: "day.tasks"
        }
      }, 'CalendarDay', day, false), _vm.$listeners))
    }))
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68a65c2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar/index.vue
// module id = 1768
// module chunks = 1